<template>
    <v-expand-transition>
        <div v-show="obj.isOpen">
            <v-form v-model="isValid" ref="form">
                <v-card-text class="pa-0">
                    <!-- 土量 -->
                    <v-card-actions class="pr-0" v-if="config.useSoilVolumeCalculation">
                        {{ $t("Soilvolume") }}
                        <v-btn height="20px" icon v-if="isEditOnProgress" @click="calculateRoadVolume(obj)"
                            title="ボリュームを計算する" :loading="obj.loadingVolume" class="ml-3">
                            <v-icon size="small">
                                mdi-play-circle-outline
                            </v-icon>
                        </v-btn>
                    </v-card-actions>
                    <v-table class="ml-4 soil-volume-table" density="compact" v-if="config.useSoilVolumeCalculation">
                        <tbody>
                            <tr>
                                <td>
                                    {{ $t("Cut") }}
                                </td>
                                <td>
                                    <v-text-field variant="underlined" hide-details density="compact" type="number"
                                        min="0" step="0.1" :suffix="volumeLabel" readonly
                                        :model-value="toDisplayVolume(obj.cutVolume ?? 0, 3).value" />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t("FILL") }}
                                </td>
                                <td>
                                    <v-text-field variant="underlined" hide-details density="compact" type="number"
                                        min="0" step="0.1" :suffix="volumeLabel" readonly
                                        :model-value="toDisplayVolume(obj.fillVolume ?? 0, 3).value" />
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                    <!-- 中心線形 -->
                    <v-card-actions class="pr-0">
                        <v-btn icon size="24" @click="toggleVisibility" class="ml-0" v-if="isEditOnProgress">
                            <v-icon>
                                {{ obj.isShow ? "icon:View" : "icon:View-Off" }}
                            </v-icon>
                        </v-btn>
                        <span class="ml-2">{{ $t("VISIBILITY") }}</span>
                    </v-card-actions>
                    <div class="ml-4">
                        <v-card-actions class="py-0 item-list">
                            <v-btn icon size="24" @click="toggleAlignmentVisibility" class="ml-0">
                                <v-icon>
                                    {{ obj.isAlignmentVisible ? "icon:View" : "icon:View-Off" }}
                                </v-icon>
                            </v-btn>
                            <span class="ml-2">{{ $t("ALIGNMENT") }}</span>
                        </v-card-actions>
                        <div class="item-list ml-8">
                            <v-card-actions class="py-0 item-list">
                                <v-btn icon size="24" @click="toggleIpLineVisibility" class="ml-0">
                                    <v-icon>
                                        {{ obj.isVisible.ipLine ? "icon:View" : "icon:View-Off" }}
                                    </v-icon>
                                </v-btn>
                                <span class="ml-2">{{ $t("IP_LINE") }}</span>
                            </v-card-actions>
                            <!-- 中心線 -->
                            <v-card-actions class="py-0 item-list">
                                <v-btn icon size="24" @click="toggleCenterLineVisibility" class="ml-0">
                                    <v-icon>
                                        {{ obj.isVisible.centerLine ? "icon:View" : "icon:View-Off" }}
                                    </v-icon>
                                </v-btn>
                                <span class="ml-2">{{ $t("CENTER_LINE") }}</span>
                            </v-card-actions>
                        </div>
                        <!-- 中心線 -->
                        <v-card-actions class="py-0 item-list">
                            <v-btn icon size="24" @click="toggleSurfaceVisibility" class="ml-0">
                                <v-icon>
                                    {{ obj.isVisible.surface ? "icon:View" : "icon:View-Off" }}
                                </v-icon>
                            </v-btn>
                            <span class="ml-2">{{ $t("SURFACE") }}</span>
                        </v-card-actions>
                        <!-- 中心線 -->
                        <v-card-actions class="py-0 item-list">
                            <v-btn icon size="24" @click="toggleEmbankmentVisibility" class="ml-0">
                                <v-icon>
                                    {{ obj.isEmbankmentVisible ? "icon:View" : "icon:View-Off" }}
                                </v-icon>
                            </v-btn>
                            <span class="ml-2">{{ $t("EMBANKMENT") }}</span>
                        </v-card-actions>
                        <div class="item-list ml-8">
                            <v-card-actions class="py-0 item-list">
                                <v-btn icon size="24" @click="toggleFillEmbankmentVisibility" class="ml-0">
                                    <v-icon>
                                        {{ obj.isVisible.fillEmbankment ? "icon:View" : "icon:View-Off" }}
                                    </v-icon>
                                </v-btn>
                                <span class="ml-2">{{ $t("FILL_EMBANKMENT") }}</span>
                            </v-card-actions>
                            <v-card-actions class="py-0 item-list">
                                <v-btn icon size="24" @click="toggleCutEmbankmentVisibility" class="ml-0">
                                    <v-icon>
                                        {{ obj.isVisible.cutEmbankment ? "icon:View" : "icon:View-Off" }}
                                    </v-icon>
                                </v-btn>
                                <span class="ml-2">{{ $t("CUT_EMBANKMENT") }}</span>
                            </v-card-actions>
                        </div>
                        <!-- 断面線 -->
                        <div class="item-list">
                            <v-card-actions class="py-0">
                                <v-btn icon size="24" @click="toggleCrossSectionVisibility" class="ml-0">
                                    <v-icon>
                                        {{ obj.isVisible.crossSection ? "icon:View" : "icon:View-Off" }}
                                    </v-icon>
                                </v-btn>
                                <span class="ml-2">{{ $t("CROSS_SECTION") }}</span>
                                <v-btn height="30px" icon v-if="isEditOnProgress"
                                    :disabled="!obj.isVisible.crossSection" @click="onUpdateCrossSection" class="ml-3">
                                    <v-icon>
                                        mdi-play-circle-outline
                                    </v-icon>
                                </v-btn>
                            </v-card-actions>
                            <!-- 線形設定値 -->
                            <v-card-actions class="section pr-2" @click="toggle('crossSection')"
                                style="cursor: pointer;" v-if="isEditOnProgress">
                                {{ $t("LineWorkparamater") }}
                                <v-spacer></v-spacer>
                                <v-icon size="small">{{ expanded.crossSection ? 'mdi-chevron-up' : 'mdi-chevron-down'
                                }}</v-icon>
                            </v-card-actions>
                            <v-expand-transition>
                                <div v-show="expanded.crossSection">
                                    <v-table density="compact">
                                        <tbody>
                                            <tr>
                                                <td>{{ $t("WidthofLineWork") }} {{ $t("Left") }}</td>
                                                <td>
                                                    <DistanceSettingInput variant="underlined" hide-details
                                                        density="compact" :min-value="1" :max-value="999.999"
                                                        :step="0.001" :decimal-length="3" :disabled="!isEditOnProgress"
                                                        v-model="obj.crossSectionSetting.leftWidth" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style="opacity: 0">{{ $t("WidthofLineWork") }}</span>
                                                    {{ $t("Right") }}
                                                </td>
                                                <td>
                                                    <DistanceSettingInput variant="underlined" hide-details
                                                        density="compact" :min-value="1" :max-value="999.999"
                                                        :step="0.001" :decimal-length="3" :disabled="!isEditOnProgress"
                                                        v-model="obj.crossSectionSetting.rightWidth" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{{ $t("STATION_INTERVAL") }}</td>
                                                <td>
                                                    <DistanceSettingInput variant="underlined" hide-details
                                                        density="compact" :min-value="1" :max-value="999.999"
                                                        :step="0.001" :decimal-length="3" :disabled="!isEditOnProgress"
                                                        v-model="obj.crossSectionSetting.interpolationPitch" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-table>
                                </div>
                            </v-expand-transition>
                        </div>
                    </div>
                    <!-- 編集モード時のみ表示 -->
                    <template v-if="isEditOnProgress">
                        <!-- 道路 -->
                        <v-card-actions class="pr-0">
                            {{ $t("Roadparameter") }}
                        </v-card-actions>
                        <v-table density="compact" class="ml-4">
                            <tbody>
                                <!-- 道路幅左 -->
                                <tr>
                                    <td>{{ $t("Widthofroad") }} {{ $t("Left") }}</td>
                                    <td>
                                        <DistanceSettingInput variant="underlined" hide-details density="compact"
                                            :min-value="0" :max-value="99.999" :decimal-length="3"
                                            :disabled="!isEditOnProgress" @blur="onBlur"
                                            v-model="obj.pathSettings.leftWidth" />
                                    </td>
                                </tr>
                                <!-- 道路幅右 -->
                                <tr>
                                    <td>
                                        <span style="opacity: 0">{{
                                            $t("Widthofroad")
                                        }}</span>
                                        {{ $t("Right") }}
                                    </td>
                                    <td>
                                        <DistanceSettingInput variant="underlined" hide-details density="compact"
                                            :min-value="0" :max-value="99.999" :decimal-length="3"
                                            :disabled="!isEditOnProgress" @blur="onBlur"
                                            v-model="obj.pathSettings.rightWidth" />
                                    </td>
                                </tr>
                                <!-- 片勾配にする -->
                                <tr>
                                    <td>{{ $t("Setsuperelevation") }}</td>
                                    <td>
                                        <v-select variant="plain" v-model="obj.pathSettings.isSuperElevation"
                                            :items="slopeTypes" item-title="label" item-value="value" density="compact"
                                            hide-details :disabled="!isEditOnProgress" class="ma-0"
                                            v-on:update:model-value="onBlur"></v-select>
                                    </td>
                                </tr>
                                <!-- 片面勾配 -->
                                <tr v-if="obj.pathSettings.isSuperElevation">
                                    <td>
                                        {{ $t("Superelevation") }}
                                    </td>
                                    <td>

                                        <SlopeSettingInput
                                            :suffix-to-display="getSuffix(roadParameterSlopeUnit.superElevation)"
                                            :is-editable="isEditOnProgress" :slope-value="obj.pathSettings.leftSlope"
                                            :step="0.01" @blur="onBlur" v-model.number="obj.pathSettings.leftSlope"
                                            :max-value="roadParameterSlopeUnit.superElevation === 'percent' ? 9999.99 : 999.99"
                                            :min-value="roadParameterSlopeUnit.superElevation === 'percent' ? -9999.99 : -999.99"
                                            :decimal-length="2"
                                            :un-valid-zero="roadParameterSlopeUnit.superElevation === 'percent'">
                                        </SlopeSettingInput>

                                    </td>
                                </tr>
                                <!-- 横断勾配 -->
                                <tr v-else>
                                    <td>
                                        {{ $t("Crossslope") }}
                                    </td>
                                    <td>

                                        <SlopeSettingInput
                                            :suffix-to-display="getSuffix(roadParameterSlopeUnit.crossSlope)"
                                            :is-editable="isEditOnProgress" :slope-value="obj.pathSettings.leftSlope"
                                            :step="0.01" @blur="onBlur" v-model.number="obj.pathSettings.leftSlope"
                                            :max-value="roadParameterSlopeUnit.crossSlope === 'percent' ? 9999.99 : 999.99"
                                            :min-value="roadParameterSlopeUnit.crossSlope === 'percent' ? 0 : 0.01"
                                            :decimal-length="2"
                                            :un-valid-zero="roadParameterSlopeUnit.crossSlope === 'percent'">
                                        </SlopeSettingInput>

                                    </td>
                                </tr>
                                <!-- 摺り付けピッチ -->
                                <tr>
                                    <td>
                                        {{ $t("InterpolationPitch") }}
                                    </td>
                                    <td>
                                        <DistanceSettingInput variant="underlined" hide-details density="compact"
                                            :min-value="0.001" :step="0.001" :max-value="99.999" :decimal-length="3"
                                            :disabled="!isEditOnProgress" @blur="onBlur"
                                            v-model="obj.pathSettings.interpolationPitch" />
                                    </td>
                                </tr>
                            </tbody>
                        </v-table>
                        <!-- 摺り付け設定 -->
                        <v-card-actions class="section ml-4 pr-2" @click="toggle('interpolation')"
                            style="cursor: pointer;">
                            {{ $t("RUBBLING_SETTINGS") }}
                            <v-spacer></v-spacer>
                            <v-icon size="small">{{ expanded.interpolation ? 'mdi-chevron-up' : 'mdi-chevron-down'
                            }}</v-icon>
                        </v-card-actions>
                        <v-expand-transition>
                            <div v-show="expanded.interpolation" class="ml-4">
                                <v-table density="compact">
                                    <tbody>
                                        <!-- 摺り付け地形タイプ -->
                                        <tr>
                                            <td>
                                                {{ $t("ASSOCIATED_TERRAIN_TYPE") }}
                                            </td>
                                            <td>
                                                <v-select variant="plain" v-model="associatedTerrain.terrainType"
                                                    :items="possibleTerrainTypes" :item-title="item => item?.label"
                                                    :item-value="item => item?.value" density="compact" hide-details
                                                    :disabled="!isEditOnProgress" class="ma-0"
                                                    @update:model-value="updateAssociatedTerrainType()">
                                                </v-select>
                                            </td>
                                        </tr>
                                        <tr v-if="associatedTerrain.terrainType === 'pointcloud'">
                                            <td>{{ $t("ASSOCIATED_POINT_CLOUD") }}</td>
                                            <td>
                                                <v-select variant="plain" v-model="associatedTerrain.id"
                                                    :items="pointClouds"
                                                    :item-title="item => item && typeof item.getName === 'function' ? item.getName() : ''"
                                                    :item-value="item => item.getAssetIdNum()" density="compact"
                                                    hide-details :disabled="!isEditOnProgress" class="ma-0"
                                                    @update:model-value="updateAssociatedTerrain()">
                                                </v-select>
                                            </td>
                                        </tr>
                                        <tr v-if="associatedTerrain.terrainType === 'design'">
                                            <td>{{ $t("ASSOCIATED_DESIGN_DATA") }}</td>
                                            <td>
                                                <v-select variant="plain" v-model="associatedTerrain.id"
                                                    :items="designs"
                                                    :item-title="item => item && typeof item.getName === 'function' ? item.getName() : ''"
                                                    :item-value="item => item.getAssetIdNum()" density="compact"
                                                    hide-details :disabled="!isEditOnProgress" class="ma-0"
                                                    @update:model-value="updateAssociatedTerrain()">
                                                </v-select>
                                            </td>
                                        </tr>
                                        <tr v-if="associatedTerrain.terrainType === 'reference-topology'">
                                            <td>{{ $t("ASSOCIATED_REFERENCE_TOPOLOGY") }}</td>
                                            <td>
                                                <v-select variant="plain" v-model="associatedTerrain.id"
                                                    :items="referenceTopologies"
                                                    :item-title="item => item && typeof item.getName === 'function' ? item.getName() : ''"
                                                    :item-value="item => item.getAssetIdNum()" density="compact"
                                                    hide-details :disabled="!isEditOnProgress" class="ma-0"
                                                    @update:model-value="updateAssociatedTerrain()">
                                                </v-select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-table>
                            </div>
                        </v-expand-transition>
                        <!-- 切土設定 -->
                        <v-card-actions class="section pr-2" @click="toggle('cut')" style="cursor: pointer;">
                            {{ $t("Cutsetting") }}
                            <v-spacer></v-spacer>
                            <v-icon size="small">{{ expanded.cut ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-card-actions>
                        <v-expand-transition>
                            <div v-show="expanded.cut" class="ml-4">
                                <v-table density="compact">
                                    <tbody>
                                        <!-- 法面高さ -->
                                        <tr>
                                            <td>
                                                {{ $t("Slopeheight") }}
                                            </td>
                                            <td>
                                                <DistanceSettingInput variant="underlined" hide-details
                                                    density="compact" :min-value="0.001" :step="0.001"
                                                    :max-value="99.999" :decimal-length="3"
                                                    :disabled="cutSlopeCondition" v-model="obj.cutSettings.roadHeight"
                                                    @blur="onBlur" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <!-- 法面勾配 -->
                                            <td>
                                                {{ $t("Slopegradient") }}
                                            </td>
                                            <td>

                                                <SlopeSettingInput
                                                    :suffix-to-display="getSuffix(cutSettingSlopeUnit.slopeGradient)"
                                                    :is-editable="(isEditOnProgress && !obj.cutSettings.isLeftRightDifferent)"
                                                    :slope-value="obj.cutSettings.moundSlope" :step="0.01"
                                                    @blur="onBlur" v-model.number="obj.cutSettings.moundSlope"
                                                    :max-value="cutSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                                                    :min-value="0.01" :decimal-length="2" :un-valid-zero="false">
                                                </SlopeSettingInput>

                                            </td>
                                        </tr>
                                    </tbody>
                                </v-table>
                                <v-card-actions class="section pr-2" @click="toggle('cutBerm')"
                                    style="cursor: pointer;">
                                    {{ $t("BERM_SETTINGS") }}
                                    <v-spacer></v-spacer>
                                    <v-icon size="small">{{ expanded.cutBerm ? 'mdi-chevron-up' : 'mdi-chevron-down'
                                        }}</v-icon>
                                </v-card-actions>
                                <v-expand-transition>
                                    <div v-show="expanded.cutBerm">
                                        <v-table density="compact">
                                            <tbody>
                                                <!-- 小段あり -->
                                                <tr>
                                                    <td>
                                                        {{ $t("Thereisberm") }}
                                                    </td>
                                                    <td>
                                                        <v-checkbox hide-details density="compact" class="ma-0"
                                                            :disabled="!isEditOnProgress"
                                                            @update:model-value="updateSettings(true)"
                                                            v-model="obj.cutSettings.generateShelf"></v-checkbox>

                                                    </td>
                                                </tr>
                                                <!-- 小段幅 -->
                                                <tr>
                                                    <td>
                                                        {{ $t("Bermwidth") }}
                                                    </td>
                                                    <td>
                                                        <DistanceSettingInput variant="underlined" hide-details
                                                            density="compact" :min-value="0.001" :max-value="99.999"
                                                            :step="0.001" :decimal-length="3"
                                                            :disabled="cutSlopeCondition"
                                                            v-model="obj.cutSettings.shelfWidth" @blur="onBlur" />
                                                    </td>
                                                </tr>
                                                <!-- 小段勾配 -->
                                                <tr>
                                                    <td>
                                                        {{ $t("Bermgradient") }}
                                                    </td>
                                                    <td>

                                                        <SlopeSettingInput
                                                            :suffix-to-display="getSuffix(cutSettingSlopeUnit.bermGradient)"
                                                            :is-editable="!cutSlopeCondition"
                                                            :slope-value="obj.cutSettings.shelfSlope" :step="0.01"
                                                            @blur="onBlur" v-model.number="obj.cutSettings.shelfSlope"
                                                            :max-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                                                            :min-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01"
                                                            :decimal-length="2"
                                                            :un-valid-zero="cutSettingSlopeUnit.bermGradient === 'percent'">
                                                        </SlopeSettingInput>

                                                    </td>
                                                </tr>
                                            </tbody>
                                        </v-table>
                                    </div>
                                </v-expand-transition>
                                <!-- 左右設定 -->
                                <v-card-actions class="section pr-2" @click="toggle('cutLeftRight')"
                                    style="cursor: pointer;">
                                    {{ $t("Leftrightsetting") }}
                                    <v-spacer></v-spacer>
                                    <v-icon size="small">{{ expanded.cutLeftRight ? 'mdi-chevron-up' :
                                        'mdi-chevron-down'
                                    }}</v-icon>
                                </v-card-actions>
                                <v-expand-transition>
                                    <div v-show="expanded.cutLeftRight">
                                        <v-table density="compact">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        {{ $t("LeftRightSettings") }}
                                                    </td>
                                                    <td>
                                                        <v-checkbox hide-details density="compact" class="ma-0"
                                                            :disabled="!isEditOnProgress"
                                                            @update:model-value="updateSettings()"
                                                            v-model="obj.cutSettings.isLeftRightDifferent"></v-checkbox>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </v-table>
                                        <div class="left-right-settings">
                                            <v-table density="compact">
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">
                                                            {{ $t("Leftcutsetting") }}
                                                        </td>
                                                    </tr>
                                                    <!-- 法面高さ -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Slopeheight") }}
                                                        </td>
                                                        <td>
                                                            <DistanceSettingInput variant="underlined" hide-details
                                                                density="compact" :min-value="0.001" :step="0.001"
                                                                :disabled="cutLeftRightCondition" :max-value="99.999"
                                                                :decimal-length="3"
                                                                v-model="obj.cutSettings.leftSlopeHeight"
                                                                @blur="onBlur" />
                                                        </td>
                                                    </tr>
                                                    <!-- 法面勾配 -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Slopegradient") }}
                                                        </td>
                                                        <td>

                                                            <SlopeSettingInput
                                                                :suffix-to-display="getSuffix(cutSettingSlopeUnit.slopeGradient)"
                                                                :is-editable="(isEditOnProgress && obj.cutSettings.isLeftRightDifferent)"
                                                                :slope-value="obj.cutSettings.leftMoundSlope"
                                                                :step="0.01" @blur="onBlur"
                                                                v-model.number="obj.cutSettings.leftMoundSlope"
                                                                :max-value="cutSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                                                                :min-value="0.01" :decimal-length="2"
                                                                :un-valid-zero="false">
                                                            </SlopeSettingInput>

                                                        </td>
                                                    </tr>
                                                    <!-- 小段幅 -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Bermwidth") }}
                                                        </td>
                                                        <td>
                                                            <DistanceSettingInput variant="underlined" hide-details
                                                                density="compact" :min-value="0.001" :step="0.001"
                                                                :disabled="cutLeftRightCondition" :max-value="99.999"
                                                                :decimal-length="3"
                                                                v-model="obj.cutSettings.leftShelfWidth"
                                                                @blur="onBlur" />
                                                        </td>
                                                    </tr>
                                                    <!-- 小段勾配 -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Bermgradient") }}
                                                        </td>
                                                        <td>

                                                            <SlopeSettingInput
                                                                :suffix-to-display="getSuffix(cutSettingSlopeUnit.bermGradient)"
                                                                :is-editable="!cutLeftRightCondition"
                                                                :slope-value="obj.cutSettings.leftShelfSlope"
                                                                @blur="onBlur" :step="0.01"
                                                                v-model.number="obj.cutSettings.leftShelfSlope"
                                                                :max-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                                                                :min-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01"
                                                                :decimal-length="2"
                                                                :un-valid-zero="cutSettingSlopeUnit.bermGradient === 'percent'">
                                                            </SlopeSettingInput>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                            <v-table density="compact">
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">
                                                            {{ $t("Rightcutsetting") }}
                                                        </td>
                                                    </tr>
                                                    <!-- 法面高さ -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Slopeheight") }}
                                                        </td>
                                                        <td>
                                                            <DistanceSettingInput variant="underlined" hide-details
                                                                density="compact" :min-value="0.001" :step="0.001"
                                                                :disabled="cutLeftRightCondition" :max-value="99.999"
                                                                :decimal-length="3"
                                                                v-model="obj.cutSettings.rightSlopeHeight"
                                                                @blur="onBlur" />
                                                        </td>
                                                    </tr>
                                                    <!-- 法面勾配 -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Slopegradient") }}
                                                        </td>
                                                        <td>

                                                            <SlopeSettingInput
                                                                :suffix-to-display="getSuffix(cutSettingSlopeUnit.slopeGradient)"
                                                                :is-editable="(isEditOnProgress && obj.cutSettings.isLeftRightDifferent)"
                                                                :slope-value="obj.cutSettings.rightMoundSlope"
                                                                :step="0.01" @blur="onBlur"
                                                                v-model.number="obj.cutSettings.rightMoundSlope"
                                                                :max-value="cutSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                                                                :min-value="0.01" :decimal-length="2"
                                                                :un-valid-zero="false">
                                                            </SlopeSettingInput>

                                                        </td>
                                                    </tr>
                                                    <!-- 小段幅 -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Bermwidth") }}
                                                        </td>
                                                        <td>
                                                            <DistanceSettingInput variant="underlined" hide-details
                                                                density="compact" :min-value="0.001" :step="0.001"
                                                                :disabled="cutLeftRightCondition" :max-value="99.999"
                                                                :decimal-length="3"
                                                                v-model="obj.cutSettings.rightShelfWidth"
                                                                @blur="onBlur" />
                                                        </td>
                                                    </tr>
                                                    <!-- 小段勾配 -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Bermgradient") }}
                                                        </td>
                                                        <td>

                                                            <SlopeSettingInput
                                                                :suffix-to-display="getSuffix(cutSettingSlopeUnit.bermGradient)"
                                                                :is-editable="!cutLeftRightCondition"
                                                                :slope-value="obj.cutSettings.rightShelfSlope"
                                                                @blur="onBlur" :step="0.01"
                                                                v-model.number="obj.cutSettings.rightShelfSlope"
                                                                :max-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                                                                :min-value="cutSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01"
                                                                :decimal-length="2"
                                                                :un-valid-zero="cutSettingSlopeUnit.bermGradient === 'percent'">
                                                            </SlopeSettingInput>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                        </div>
                                    </div>
                                </v-expand-transition>
                            </div>
                        </v-expand-transition>
                        <!-- 盛土設定 -->
                        <v-card-actions class="section pr-2" @click="toggle('fill')" style="cursor: pointer;">
                            {{ $t("Fillsetting") }}
                            <v-spacer></v-spacer>
                            <v-icon size="small">{{ expanded.fill ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-card-actions>
                        <v-expand-transition>
                            <div v-show="expanded.fill" class="ml-4">
                                <v-table density="compact">
                                    <tbody>
                                        <!-- 法面高さ -->
                                        <tr>
                                            <td>
                                                {{ $t("Slopeheight") }}
                                            </td>
                                            <td>
                                                <DistanceSettingInput variant="underlined" hide-details
                                                    density="compact" :min-value="0.001" :max-value="99.999"
                                                    :step="0.001" :disabled="embSlopeCondition" :decimal-length="3"
                                                    v-model="obj.fillSettings.roadHeight" @blur="onBlur" />
                                            </td>
                                        </tr>
                                        <!-- 法面勾配 -->
                                        <tr>
                                            <td>
                                                {{ $t("Slopegradient") }}
                                            </td>
                                            <td>

                                                <SlopeSettingInput
                                                    :suffix-to-display="getSuffix(fillSettingSlopeUnit.slopeGradient)"
                                                    :is-editable="!(!isEditOnProgress || obj.fillSettings.isLeftRightDifferent)"
                                                    :slope-value="obj.fillSettings.moundSlope" :step="0.01"
                                                    @blur="onBlur" v-model.number="obj.fillSettings.moundSlope"
                                                    :max-value="fillSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                                                    :min-value="0.01" :decimal-length="2" :un-valid-zero="false">
                                                </SlopeSettingInput>

                                            </td>
                                        </tr>
                                    </tbody>
                                </v-table>
                                <!-- 小段設定 -->
                                <v-card-actions class="section pr-2" @click="toggle('fillBerm')"
                                    style="cursor: pointer;">
                                    {{ $t("BERM_SETTINGS") }}
                                    <v-spacer></v-spacer>
                                    <v-icon size="small">{{ expanded.fillBerm ? 'mdi-chevron-up' : 'mdi-chevron-down'
                                        }}</v-icon>
                                </v-card-actions>
                                <v-expand-transition>
                                    <div v-show="expanded.fillBerm">
                                        <v-table density="compact">
                                            <tbody>
                                                <!-- 小段あり -->
                                                <tr>
                                                    <td>
                                                        {{ $t("Thereisberm") }}
                                                    </td>
                                                    <td>
                                                        <v-checkbox hide-details density="compact" class="ma-0"
                                                            :disabled="!isEditOnProgress"
                                                            @update:model-value="updateSettings(true)"
                                                            v-model="obj.fillSettings.generateShelf"></v-checkbox>
                                                    </td>
                                                </tr>
                                                <!-- 小段幅 -->
                                                <tr>
                                                    <td>
                                                        {{ $t("Bermwidth") }}
                                                    </td>
                                                    <td>
                                                        <DistanceSettingInput variant="underlined" hide-details
                                                            density="compact" :min-value="0.001" :max-value="99.999"
                                                            :step="0.001" :disabled="embSlopeCondition"
                                                            :decimal-length="3" v-model="obj.fillSettings.shelfWidth"
                                                            @blur="onBlur" />
                                                    </td>
                                                </tr>
                                                <!-- 小段勾配 -->
                                                <tr>
                                                    <td>
                                                        {{ $t("Bermgradient") }}
                                                    </td>
                                                    <td>

                                                        <SlopeSettingInput
                                                            :suffix-to-display="getSuffix(fillSettingSlopeUnit.bermGradient)"
                                                            :is-editable="!embSlopeCondition"
                                                            :slope-value="obj.fillSettings.shelfSlope" :step="0.01"
                                                            @blur="onBlur" v-model.number="obj.fillSettings.shelfSlope"
                                                            :max-value="fillSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                                                            :min-value="fillSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01"
                                                            :decimal-length="2"
                                                            :un-valid-zero="fillSettingSlopeUnit.bermGradient === 'percent'">
                                                        </SlopeSettingInput>

                                                    </td>
                                                </tr>
                                            </tbody>
                                        </v-table>
                                    </div>
                                </v-expand-transition>

                                <!-- 左右設定 -->
                                <v-card-actions class="section pr-2" @click="toggle('fillLeftRight')"
                                    style="cursor: pointer;">
                                    {{ $t("Leftrightsetting") }}
                                    <v-spacer></v-spacer>
                                    <v-icon size="small">{{ expanded.fillLeftRight ? 'mdi-chevron-up' :
                                        'mdi-chevron-down'
                                    }}</v-icon>
                                </v-card-actions>
                                <v-expand-transition>
                                    <div v-show="expanded.fillLeftRight">
                                        <v-table density="compact">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        {{ $t("LeftRightSettings") }}
                                                    </td>
                                                    <td>
                                                        <v-checkbox hide-details density="compact" class="ma-0"
                                                            :disabled="!isEditOnProgress"
                                                            @update:model-value="updateSettings()"
                                                            v-model="obj.fillSettings.isLeftRightDifferent"></v-checkbox>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </v-table>
                                        <div class="left-right-settings">
                                            <v-table density="compact">
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">
                                                            {{ $t("Leftfillsetting") }}
                                                        </td>
                                                    </tr>
                                                    <!-- 法面高さ -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Slopeheight") }}
                                                        </td>
                                                        <td>
                                                            <DistanceSettingInput variant="underlined" hide-details
                                                                density="compact" :min-value="0.001" :step="0.001"
                                                                :disabled="embLeftRightCondition" :max-value="99.999"
                                                                :decimal-length="3" @blur="onBlur"
                                                                v-model="obj.fillSettings.leftSlopeHeight" />
                                                        </td>
                                                    </tr>
                                                    <!-- 法面勾配 -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Slopegradient") }}
                                                        </td>
                                                        <td>

                                                            <SlopeSettingInput
                                                                :suffix-to-display="getSuffix(fillSettingSlopeUnit.slopeGradient)"
                                                                :is-editable="(isEditOnProgress && obj.fillSettings.isLeftRightDifferent)"
                                                                :slope-value="obj.fillSettings.leftMoundSlope"
                                                                :step="0.01" @blur="onBlur"
                                                                v-model.number="obj.fillSettings.leftMoundSlope"
                                                                :max-value="fillSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                                                                :min-value="0.01" :decimal-length="2"
                                                                :un-valid-zero="false">
                                                            </SlopeSettingInput>

                                                        </td>
                                                    </tr>
                                                    <!-- 小段幅 -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Bermwidth") }}
                                                        </td>
                                                        <td>
                                                            <DistanceSettingInput variant="underlined" hide-details
                                                                density="compact" :min-value="0.001" :step="0.001"
                                                                :disabled="embLeftRightCondition" :max-value="99.999"
                                                                :decimal-length="3"
                                                                v-model="obj.fillSettings.leftShelfWidth"
                                                                @blur="onBlur" />
                                                        </td>
                                                    </tr>
                                                    <!-- 小段勾配 -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Bermgradient") }}
                                                        </td>
                                                        <td>

                                                            <SlopeSettingInput
                                                                :suffix-to-display="getSuffix(fillSettingSlopeUnit.bermGradient)"
                                                                :is-editable="!embLeftRightCondition"
                                                                :slope-value="obj.fillSettings.leftShelfSlope"
                                                                :step="0.01" @blur="onBlur"
                                                                v-model.number="obj.fillSettings.leftShelfSlope"
                                                                :max-value="fillSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                                                                :min-value="fillSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01"
                                                                :decimal-length="2"
                                                                :un-valid-zero="fillSettingSlopeUnit.bermGradient === 'percent'">
                                                            </SlopeSettingInput>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                            <v-table density="compact">
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">
                                                            {{ $t("Rightfillsetting") }}
                                                        </td>
                                                    </tr>
                                                    <!-- 法面高さ -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Slopeheight") }}
                                                        </td>
                                                        <td>
                                                            <DistanceSettingInput variant="underlined" hide-details
                                                                density="compact" :min-value="0.001" :step="0.001"
                                                                :disabled="embLeftRightCondition" :decimal-length="3"
                                                                :max-value="99.999" @blur="onBlur"
                                                                v-model="obj.fillSettings.rightSlopeHeight" />
                                                        </td>
                                                    </tr>
                                                    <!-- 法面勾配 -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Slopegradient") }}
                                                        </td>
                                                        <td>

                                                            <SlopeSettingInput
                                                                :suffix-to-display="getSuffix(fillSettingSlopeUnit.slopeGradient)"
                                                                :is-editable="(isEditOnProgress && obj.fillSettings.isLeftRightDifferent)"
                                                                :slope-value="obj.fillSettings.rightMoundSlope"
                                                                :step="0.01" @blur="onBlur"
                                                                v-model.number="obj.fillSettings.rightMoundSlope"
                                                                :max-value="fillSettingSlopeUnit.slopeGradient === 'percent' ? 9999.99 : 999.99"
                                                                :min-value="0.01" :decimal-length="2"
                                                                :un-valid-zero="false">
                                                            </SlopeSettingInput>

                                                        </td>
                                                    </tr>
                                                    <!-- 小段幅 -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Bermwidth") }}
                                                        </td>
                                                        <td>
                                                            <DistanceSettingInput variant="underlined" hide-details
                                                                density="compact" :min-value="0.001" :step="0.001"
                                                                :disabled="embLeftRightCondition" :max-value="99.999"
                                                                :decimal-length="3"
                                                                v-model="obj.fillSettings.rightShelfWidth"
                                                                @blur="onBlur" />
                                                        </td>
                                                    </tr>
                                                    <!-- 小段勾配 -->
                                                    <tr>
                                                        <td>
                                                            {{ $t("Bermgradient") }}
                                                        </td>
                                                        <td>

                                                            <SlopeSettingInput
                                                                :suffix-to-display="getSuffix(fillSettingSlopeUnit.bermGradient)"
                                                                :is-editable="!embLeftRightCondition"
                                                                :slope-value="obj.fillSettings.rightShelfSlope"
                                                                :step="0.01" @blur="onBlur"
                                                                v-model.number="obj.fillSettings.rightShelfSlope"
                                                                :max-value="fillSettingSlopeUnit.bermGradient === 'percent' ? 9999.99 : 999.99"
                                                                :min-value="fillSettingSlopeUnit.bermGradient === 'percent' ? 0 : 0.01"
                                                                :decimal-length="2"
                                                                :un-valid-zero="fillSettingSlopeUnit.bermGradient === 'percent'">
                                                            </SlopeSettingInput>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                        </div>
                                    </div>
                                </v-expand-transition>
                            </div>
                        </v-expand-transition>
                        <!-- 色設定 -->
                        <v-card-actions class="section pr-2" @click="toggle('color')" style="cursor: pointer;">
                            {{ $t("COLOR_SETTINGS") }}
                            <v-spacer></v-spacer>
                            <v-icon size="small">{{ expanded.color ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-card-actions>
                        <v-expand-transition>
                            <div v-show="expanded.color" class="ml-4">
                                <!-- 透明度 -->
                                <v-card-actions class="py-0 mr-3">
                                    {{ $t("OPACITY") }}
                                    <v-slider v-model="obj.transparency" :disabled="!isEditOnProgress" hide-details
                                        max="1" step="0.01" class="ml-1" color="primary" track-size="0.5"
                                        thumb-size="14"></v-slider>
                                </v-card-actions>
                                <v-table density="compact">
                                    <tbody>
                                        <!-- 路面色 -->
                                        <tr>
                                            <td>
                                                {{ $t("ROAD_SURFACE_COLOR") }}
                                            </td>
                                            <td>
                                                <v-menu :disabled="!isEditOnProgress">
                                                    <template v-slot:activator="{ props }">
                                                        <v-avatar :color="obj.pathSettings.surfaceColor" size="20px"
                                                            v-bind="props">
                                                        </v-avatar>
                                                    </template>
                                                    <v-color-picker class="ma-0" hide-canvas hide-inputs hide-sliders
                                                        show-swatches mode="hexa"
                                                        v-model="obj.pathSettings.surfaceColor"></v-color-picker>
                                                </v-menu>
                                            </td>
                                        </tr>
                                        <!-- 切土法面色 -->
                                        <tr>
                                            <td>
                                                {{ $t("CUT_SLOPE_COLOR") }}
                                            </td>
                                            <td>
                                                <v-menu :disabled="!isEditOnProgress">
                                                    <template v-slot:activator="{ props }">
                                                        <v-avatar :color="obj.cutSettings.color" size="20px"
                                                            v-bind="props">
                                                        </v-avatar>
                                                    </template>
                                                    <v-color-picker class="ma-0" hide-canvas hide-inputs hide-sliders
                                                        show-swatches mode="hexa"
                                                        v-model="obj.cutSettings.color"></v-color-picker>
                                                </v-menu>
                                            </td>
                                        </tr>
                                        <!-- 盛土法面色 -->
                                        <tr>
                                            <td>
                                                {{ $t("FILL_SLOPE_COLOR") }}
                                            </td>
                                            <td>
                                                <v-menu :disabled="!isEditOnProgress">
                                                    <template v-slot:activator="{ props }">
                                                        <v-avatar :color="obj.fillSettings.color" size="20px"
                                                            v-bind="props">
                                                        </v-avatar>
                                                    </template>
                                                    <v-color-picker class="ma-0" hide-canvas hide-inputs hide-sliders
                                                        show-swatches mode="hexa"
                                                        v-model="obj.fillSettings.color"></v-color-picker>
                                                </v-menu>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-table>
                            </div>
                        </v-expand-transition>
                    </template>
                </v-card-text>
            </v-form>

        </div>
    </v-expand-transition>
    <div v-if="obj.showSlope2DInput">
        <Slope2dValueInput :objId="obj.id" :slopeValue="obj.slope2DInput.slopeValue"
            :slopeUnit="obj.slope2DInput.slopeUnit" :slopeIndex="obj.slope2DInput.slopeIndex"
            :posX="obj.slope2DInput.clientX" :posY="obj.slope2DInput.clientY" @close="close2dValueInput">
        </Slope2dValueInput>
    </div>
</template>

<script>
import "@/assets/icons/style.css";
import config from "@/config.json";
import { TerrainType } from "@/constant.js";
import * as cesiumCommon from "@/utils/cesium-common";
import {
	notifySuccess,
	notifyWarning,
	notifyError,
} from "@/utils/notificationUtils";
import { mapMutations } from "vuex";
import { UnitTypes } from "../../../constant";
import {
	GoogleAnalyticsClickTypes,
	addClickTypeLog,
} from "../../../utils/googleAnalytics.js";
import Slope2dValueInput from "../../Slope2dValueInput.vue";
import SlopeRangeComponent from "../SlopeRangeComponent.vue";
import SlopeSettingInput from "../SlopeSettingInput.vue";
import NumericSettingInput from "../NumericSettingInput.vue";
import DistanceSettingInput from "../DistanceSettingInput.vue";
import { isCrossSectionSettingValid } from "./cross-section-validation";
import { useObjectPanel } from "./composables/useObjectPanel";
import { useUnitDisplay } from "@/composables/useUnitDisplay";

export default {
	setup(props) {
		const { obj, isValid, form } = useObjectPanel(props.objId);
		const { toDisplayVolume, volumeLabel } = useUnitDisplay();
		return {
			obj,
			isValid,
			form,
			toDisplayVolume,
			volumeLabel,
		};
	},
	name: "RoadPanel",
	emits: ["update:valid"],
	components: {
		SlopeSettingInput,
		SlopeRangeComponent,
		Slope2dValueInput,
		NumericSettingInput,
		DistanceSettingInput,
	},
	props: {
		objId: String,
		rules: Object,
	},
	computed: {
		isEditOnProgress() {
			return this.$store.state.object.objectUnderEdit?.id === this.obj.id;
		},
		possibleTerrainTypes() {
			const terrainTypes = [];
			if (this.pointClouds.length > 0) {
				terrainTypes.push({
					label: this.$t("PointCloud"),
					value: "pointcloud",
				});
			}
			if (this.designs.length > 0) {
				terrainTypes.push({
					label: this.$t("DesignData"),
					value: "design",
				});
			}
			if (this.referenceTopologies.length > 0) {
				terrainTypes.push({
					label: this.$t("ReferenceTopology"),
					value: "reference-topology",
				});
			}
			return terrainTypes;
		},
		pointClouds() {
			return this.$store.getters.terrainList
				.filter((item) => item.getType() === TerrainType.POINT_CLOUD)
				.filter((item) => item.getIsAssetUploaded() === "DONE");
		},
		designs() {
			return this.$store.getters.terrainList
				.filter((item) => item.getType() === TerrainType.DESIGN_DATA)
				.filter((item) => item.getIsAssetUploaded() === "DONE");
		},
		referenceTopologies() {
			return this.$store.getters.terrainList.filter(
				(item) => item.getType() === TerrainType.REFERENCE_TOPOLOGY,
			);
		},
		roadParameterSlopeUnit() {
			return this.$store.state.roadParameterSlopeUnit;
		},
		cutSettingSlopeUnit() {
			return this.$store.state.cutSettingSlopeUnit;
		},
		fillSettingSlopeUnit() {
			return this.$store.state.fillSettingSlopeUnit;
		},
		slopeTypes() {
			return [
				{
					label: this.$t("Crossslope"),
					value: false,
				},
				{
					label: this.$t("Superelevation"),
					value: true,
				},
			];
		},
		// Disabling condition for cut setting's - shelfSlope, shelfWidth
		cutSlopeCondition() {
			return (
				!this.isEditOnProgress ||
				this.obj.cutSettings.isLeftRightDifferent ||
				!this.obj.cutSettings.generateShelf
			);
		},
		// Disabling condition for cut setting's - leftShelfWidth, leftShelfSlope, rightShelfWidth, rightShelfSlope
		cutLeftRightCondition() {
			return !(
				this.isEditOnProgress &&
				this.obj.cutSettings.isLeftRightDifferent &&
				this.obj.cutSettings.generateShelf
			);
		},
		// Disabling condition for embankment setting's - shelfSlope, shelfWidth
		embSlopeCondition() {
			return (
				!this.isEditOnProgress ||
				this.obj.fillSettings.isLeftRightDifferent ||
				!this.obj.fillSettings.generateShelf
			);
		},
		// Disabling condition for embankment setting's - leftShelfWidth, leftShelfSlope, rightShelfWidth, rightShelfSlope
		embLeftRightCondition() {
			return !(
				this.isEditOnProgress &&
				this.obj.fillSettings.isLeftRightDifferent &&
				this.obj.fillSettings.generateShelf
			);
		},
	},
	data() {
		return {
			config,
			expanded: {
				crossSection: false,
				interpolation: false,
				cut: false,
				cutLeftRight: false,
				cutBerm: false,
				fill: false,
				fillLeftRight: false,
				fillBerm: false,
				color: false,
			},
			associatedTerrain: {
				id: null,
				terrainType: null,
			},
		};
	},
	watch: {
		isValid(newVal) {
			this.$emit("update:valid", newVal);
		},
	},
	methods: {
		...mapMutations(["set_snackbar", "reset_snackbars"]),
		toggle(section) {
			this.expanded[section] = !this.expanded[section];
		},
		getSuffix(unitType) {
			const unit = UnitTypes.find((type) => type.value === unitType);
			return unit.symbol;
		},
		isNum(val) {
			return typeof val == "number";
		},
		async onBlur() {
			await this.updateSettings(true);
		},
		async updateSettings(updateInViewer = false) {
			this.$store.dispatch("startObjectUpdating");
			try {
				await this.$nextTick();
				if (!this.obj.isShow) {
					updateInViewer = false;
				}
				const validation = await this.$refs.form.validate();
				if (!validation.valid) return;
				await this.obj.update(this.obj, updateInViewer);

				// Update center line and cross section after road settings change
				if (updateInViewer && this.obj.crossSectionSetting) {
					await dispatch(
						"lineWorksCrossSection/saveCrossSectionOfLineWorks",
						{
							crossSectionSetting: {
								...this.obj.crossSectionSetting,
								name: this.obj.name,
							},
						},
						{ root: true },
					);
				}
			} finally {
				this.$store.dispatch("endObjectUpdating");
			}
		},

		async updateAssociatedTerrain() {
			this.$store.dispatch("startObjectUpdating");
			this.reset_snackbars();
			if (!this.associatedTerrain?.id) {
				notifyWarning(this, this.$t("SELECT_ASSOCIATED_TERRAIN"));
				return;
			}
			let hasUpdateError = false;
			try {
				const terrain = this.$store.getters.terrainList.find(
					(terrain) =>
						terrain.getAssetIdNum() === this.associatedTerrain.id &&
						terrain.getType() === this.associatedTerrain.terrainType,
				);
				if (!terrain) {
					throw new Error("Terrain not found");
				}
				await cesiumCommon.setAssociatedTerrainVisible(terrain);
				await this.obj.updateAssociatedTerrain(
					this.associatedTerrain.id,
					this.associatedTerrain.terrainType,
				);
			} catch {
				hasUpdateError = true;
				this.associatedTerrain.id = this.obj.associatedTerrain.id;
				this.associatedTerrain.terrainType =
					this.obj.associatedTerrain.terrainType;
			} finally {
				this.$store.dispatch("endObjectUpdating");
			}
		},
		async calculateRoadVolume(obj) {
			// Google Analyticsに連携
			addClickTypeLog(GoogleAnalyticsClickTypes.P_CLICK_OBJECT_VOLUME_CALC);

			obj.loadingVolume = true;
			try {
				const res = await this.$store.getters.viewer.volumeCalculationForRoad(
					obj.id,
				);
				obj.cutVolume = res.cutVolume.toFixed(3);
				obj.fillVolume = res.fillVolume.toFixed(3);
			} catch (error) {
				console.error(error.message);
			} finally {
				obj.loadingVolume = false;
			}
			this.$forceUpdate();
		},
		unit() {
			return this.$store.state.slopeUnit;
		},
		updateAssociatedTerrainType() {
			this.associatedTerrain.id = null;
			this.reset_snackbars();
			// Show instruction message until user completes the operation (timeout: -1 for manual dismissal)
			notifySuccess(
				{ $store: this.$store, $t: this.$t },
				this.$t("SELECT_ASSOCIATED_TERRAIN"),
				-1,
			);
		},
		close2dValueInput() {
			this.obj.showSlope2DInput = false;
		},
		async toggleVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isShow;
						await this.obj.setVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle visibility:", e);
					}
				},
				{ root: true },
			);
		},
		async toggleCenterLineVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isVisible.centerLine;
						await this.obj.setCenterLineVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle center alignment visibility:", e);
					}
				},
				{ root: true },
			);
		},
		async toggleIpLineVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isVisible.ipLine;
						await this.obj.setIpLineVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle ip line visibility:", e);
					}
				},
				{ root: true },
			);
		},
		async toggleAlignmentVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isAlignmentVisible;
						await this.obj.setAlignmentVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle alignment visibility:", e);
					}
				},
				{ root: true },
			);
		},
		async toggleSurfaceVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isVisible.surface;
						await this.obj.setSurfaceVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle surface visibility:", e);
					}
				},
				{ root: true },
			);
		},
		async toggleEmbankmentVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isEmbankmentVisible;
						await this.obj.setEmbankmentVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle embankment visibility:", e);
					}
				},
				{ root: true },
			);
		},
		async toggleFillEmbankmentVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isVisible.fillEmbankment;
						await this.obj.setFillEmbankmentVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle fill embankment visibility:", e);
					}
				},
				{ root: true },
			);
		},
		async toggleCutEmbankmentVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isVisible.cutEmbankment;
						await this.obj.setCutEmbankmentVisibility(!currentState);
					} catch (e) {
						console.error("Failed to toggle cut embankment visibility:", e);
					}
				},
				{ root: true },
			);
		},
		async toggleCrossSectionVisibility() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						const currentState = this.obj.isVisible.crossSection;
						await this.obj.setCrossSectionVisibility(!currentState);
					} catch (e) {
						console.error("Failed to generate cross section:", e);
					}
				},
				{ root: true },
			);
		},
		async onUpdateCrossSection() {
			await this.$store.dispatch(
				"executeWithSpinner",
				async () => {
					try {
						await this.obj.updateCrossSection();
					} catch (e) {
						console.error("Failed to update cross section visual:", e);
					}
				},
				{ root: true },
			);
		},
	},
	mounted() {
		this.associatedTerrain.id = this.obj.associatedTerrain.id;
		this.associatedTerrain.terrainType = this.obj.associatedTerrain.terrainType;
	},
};
</script>

<style scoped>
tr td {
    padding: 0 8px !important;
}

tr td:first-child {
    width: 115px;
}

.v-card-actions.section:hover {
    background-color: rgba(var(--v-theme-on-surface), 0.08);
}

.v-table {
    background-color: transparent;
}

.soil-volume-table tr td:first-child {
    width: 80px;
    max-width: 80px;
}

.v-table :deep(.v-select .v-select__selection-text) {
    white-space: normal;
    font-size: 14px;
}
</style>
